```vue
<template>
  <BreadCrumb PageTitle="Reprendre une session" />
  <ReprendreSession />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ReprendreSession from "@/components/Session/ReprendreSession.vue";

export default defineComponent({
  name: "ReprendreSessionPage",
  components: {
    BreadCrumb,
    ReprendreSession,
  },
});
</script>